var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "owners" } },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-button",
            {
              staticClass: "create-button",
              attrs: { type: "primary" },
              on: { click: _vm.openCreateDialog },
            },
            [_vm._v(_vm._s(_vm.$t("Owners.create")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("OwnersTable", {
            staticClass: "group",
            attrs: { owners: _vm.owners, edit: false, loading: _vm.isLoading },
            on: { openCreateDialog: _vm.openCreateDialog },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Owners.create"),
            width: "65%",
            top: "8vh",
            visible: _vm.isShowingDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowingDialog = $event
            },
            closed: _vm.closedDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoadingOwnerSetting,
                  expression: "isLoadingOwnerSetting",
                },
              ],
              ref: "dialogForm",
              staticClass: "form",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                "label-width": "250px",
                model: _vm.dialogForm,
              },
            },
            [
              _vm.user.company.type === "admin"
                ? [
                    _c(
                      "div",
                      { staticClass: "split" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Owners.company.type"),
                              prop: "company.type",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "types",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "Owners.select_placeholder",
                                    { select: _vm.$t("Owners.company.type") }
                                  ),
                                },
                                model: {
                                  value: _vm.dialogForm.company.type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dialogForm.company,
                                      "type",
                                      $$v
                                    )
                                  },
                                  expression: "dialogForm.company.type",
                                },
                              },
                              _vm._l(_vm.types, function (type, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    value: type,
                                    label: _vm.$t(
                                      "Owners.company.types." + type
                                    ),
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "div",
                { staticClass: "split" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.name"),
                        prop: "company.name",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "name",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.name"),
                          }),
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.company, "name", $$v)
                          },
                          expression: "dialogForm.company.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.kana"),
                        prop: "company.name_kana",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "kana",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.kana"),
                          }),
                          maxlength: "128",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.name_kana,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.company, "name_kana", $$v)
                          },
                          expression: "dialogForm.company.name_kana",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.zip_code"),
                        prop: "company.zip_code",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "zip_code",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.zip_code"),
                          }),
                          maxlength: "7",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.zip_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.company, "zip_code", $$v)
                          },
                          expression: "dialogForm.company.zip_code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.address"),
                        prop: "company.address",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.address"),
                          }),
                          maxlength: "128",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.company, "address", $$v)
                          },
                          expression: "dialogForm.company.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.phone_number"),
                        prop: "company.phone_number",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "tel",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.phone_number"),
                          }),
                          maxlength: "16",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.phone_number,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dialogForm.company,
                              "phone_number",
                              $$v
                            )
                          },
                          expression: "dialogForm.company.phone_number",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.fax_number"),
                        prop: "company.fax_number",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "tel",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.fax_number"),
                          }),
                          maxlength: "16",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.fax_number,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.company, "fax_number", $$v)
                          },
                          expression: "dialogForm.company.fax_number",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.invoice_email"),
                        prop: "company.invoice_email",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.company.invoice_email"),
                          }),
                          maxlength: "128",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.company.invoice_email,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dialogForm.company,
                              "invoice_email",
                              $$v
                            )
                          },
                          expression: "dialogForm.company.invoice_email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "split" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.owner.name"),
                        prop: "owner.name",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "name",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.owner.name"),
                          }),
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogForm.owner.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.owner, "name", $$v)
                          },
                          expression: "dialogForm.owner.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.owner.email"),
                        prop: "owner.email",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.owner.email"),
                          }),
                          maxlength: "128",
                          "show-word-limit": "",
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.dialogForm.owner.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.owner, "email", $$v)
                          },
                          expression: "dialogForm.owner.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.owner.password"),
                        prop: "owner.password",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "password",
                        attrs: {
                          placeholder: _vm.$t("Owners.input_placeholder", {
                            input: _vm.$t("Owners.owner.password"),
                          }),
                          "show-password": "",
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.dialogForm.owner.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm.owner, "password", $$v)
                          },
                          expression: "dialogForm.owner.password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "split" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Owners.company.timezone"),
                        prop: "company.timezone",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "timezones",
                          attrs: {
                            size: "medium",
                            placeholder: _vm.$t("Owners.select_placeholder", {
                              select: _vm.$t("Owners.company.timezone"),
                            }),
                          },
                          model: {
                            value: _vm.dialogForm.company.timezone_tzinfo_ident,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dialogForm.company,
                                "timezone_tzinfo_ident",
                                $$v
                              )
                            },
                            expression:
                              "dialogForm.company.timezone_tzinfo_ident",
                          },
                        },
                        _vm._l(_vm.timezones, function (tz) {
                          return _c("el-option", {
                            key: tz.city,
                            attrs: {
                              value: tz.city,
                              label:
                                "GMT" +
                                tz.offset +
                                " " +
                                _vm.$t("MetaZones." + tz.metazone) +
                                " (" +
                                _vm.$t("TimezoneCities." + tz.city) +
                                ")",
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Owners.company.note") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3 },
                    model: {
                      value: _vm.dialogForm.company.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm.company, "notes", $$v)
                      },
                      expression: "dialogForm.company.notes",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.isLoadingOwnerSetting },
                  on: {
                    click: function ($event) {
                      _vm.isShowingDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Cuona.Group.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.isLoadingOwnerSetting,
                    loading: _vm.isCreateLoading,
                  },
                  on: { click: _vm.createOwner },
                },
                [_vm._v(_vm._s(_vm.$t("Cuona.Group.create")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }